import { GuideVariant } from '../core'
import { ContactNote } from '../components/ContactNote'
import { DEFAULT_SECTIONS } from './default'

/**
 * アイセイ薬局 (/guide/aisei)。本文は共通版と同じで、連絡先だけが違う。
 * 店舗 → 社内の窓口 → 情報システム部 → mediLab の流れなので、mediLab の support@ は出さず
 * 本部サポートデスクへ。電話番号は紙にも web にも載せない (まもる君のアイセイ版と同じ語)。
 */
export const aiseiVariant: GuideVariant = {
  sections: DEFAULT_SECTIONS,
  contact: <ContactNote>本部サポートデスクへご連絡ください。</ContactNote>,
}
